import { AnalogueSource, AnalyticsAnalogues } from './procurement-analytics.types';

const sourceNames: Record<AnalogueSource, string> = {
  MANUAL: 'Ручные аналоги',
  SUPPLIER: 'Поставщики',
  TECDOC: 'TecDoc',
  EXTERNAL_CATALOG: 'Каталог кроссов'
};

/** Explain blockers without treating unmatched, non-local candidates as errors. */
export function analogueCalculationBlockers(
  result: {
    sourceStates: AnalyticsAnalogues['sourceStates'];
    ambiguousCandidates?: AnalyticsAnalogues['candidates'];
  },
  selectedSources: AnalogueSource[]
): string[] {
  const reasons: string[] = [];
  for (const candidate of result.ambiguousCandidates || []) {
    if (candidate.matchStatus !== 'ambiguous') continue;
    const cross = `Кросс ${candidate.brand} ${candidate.article}`;
    const products = candidate.productIds.map((id) => `ID ${id}`).join(', ');
    if ((candidate.conflictingBrands || []).length > 1) {
      const brands = candidate.conflictingBrands!
        .map((brand) => `${brand.description} (ID ${brand.id})`).join(', ');
      reasons.push(`${cross}: бренд неоднозначен — ${brands}. ` +
        (products ? `Найденные товары: ${products}. ` : '') +
        'Проверьте дубли и названия брендов в справочнике.');
    } else if (candidate.productIds.length > 1) {
      reasons.push(`${cross}: найдено несколько товаров — ${products}. Проверьте карточки и связи аналогов.`);
    } else {
      reasons.push(`${cross}: неоднозначная связь с каталогом. Проверьте бренд и артикул.`);
    }
  }
  for (const source of selectedSources) {
    const state = result.sourceStates.find((item) => item.source === source);
    if (state?.status === 'ready' && state.complete) continue;
    const detail = state?.message || (state?.status === 'error' ? 'источник недоступен.' :
      state?.status === 'loading' ? 'загрузка ещё не завершена.' : 'данные загружены не полностью.');
    reasons.push(`${sourceNames[source]}: ${detail}`);
  }
  return [...new Set(reasons)];
}
